import SectionCard from "./section-card";

const EventDetailsCard = ({ about, title, titleFont, textFont }) => {
  if (!about) return null;

  return (
    <SectionCard className="flex flex-col gap-3 px-3 py-4" id="aboutCompanyBlock">
      <p
        className="relative pb-3 text-center text-xl leading-5 font-medium text-event-900 after:absolute after:bottom-0 after:left-1/2 after:h-px after:w-1/2 after:-translate-x-1/2 after:bg-black/5"
        style={titleFont ? { fontFamily: titleFont } : undefined}
      >
        {title}
      </p>
      <p
        className="text-center text-[12px] leading-[17px] font-normal text-event-500"
        style={{
          fontFamily: textFont,
          overflowWrap: "anywhere",
          whiteSpace: "pre-line",
        }}
      >
        {about}
      </p>
    </SectionCard>
  );
};

export default EventDetailsCard;
